import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=3fd85e38&"
import script from "./CountDown.vue?vue&type=script&lang=ts&"
export * from "./CountDown.vue?vue&type=script&lang=ts&"
import style0 from "./CountDown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports